// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3kIta","productName":"Table_productName__HXau7"};